import axios from 'axios'
import * as types from '../mutation-types'

import { ORDER_SUMMARY_PREVIEW } from '~/mockup/dashboard.data'

// state
export const state = {
  tradeShows: [],
  draftOrders: [],
  invoiceStatuses: [],
  orders: [],
  contacts: [],
  collections: [],
  orderSummary: []
}

// getters
export const getters = {
  tradeShows: state => state.tradeShows,
  draftOrders: state => state.draftOrders,
  invoiceStatuses: state => state.invoiceStatuses,
  orders: state => state.orders,
  contacts: state => state.contacts,
  collections: state => state.collections,
  orderSummary: state => state.orderSummary
}

// mutations
export const mutations = {
  [types.FETCH_TRADESHOWS_SUCCESS] (state, { tradeShows }) {
    state.tradeShows = tradeShows
  },

  [types.FETCH_DRAFT_ORDERS_SUCCESS] (state, { draftOrders }) {
    state.draftOrders = draftOrders
  },

  [types.FETCH_ORDERS_SUCCESS] (state, { orders }) {
    state.orders = orders
  },

  [types.FETCH_INVOICE_STATUSES_SUCCESS] (state, { invoiceStatuses }) {
    state.invoiceStatuses = invoiceStatuses
  },

  [types.FETCH_CONTACTS_SUCCESS] (state, { contacts }) {
    state.contacts = contacts
  },

  [types.FETCH_COLLECTIONS_SUCCESS] (state, { collections }) {
    state.collections = collections
  },

  [types.FETCH_ORDER_SUMMARY_SUCCESS] (state, { orderSummary }) {
    state.orderSummary = orderSummary
  },

  [types.FETCH_ORDER_SUMMARY_FAILURE] (state) {
    state.orderSummary = []
  }
}

// actions
export const actions = {
  async fetchBuyerDashboard ({ commit }) {
    try {
      const { data } = await axios.get('/api/user/buyer-dashboard')

      commit(types.FETCH_TRADESHOWS_SUCCESS, {
        tradeShows: data.data.trade_shows
      })
      commit(types.FETCH_DRAFT_ORDERS_SUCCESS, {
        draftOrders: data.data.draft_orders
      })
      commit(types.FETCH_INVOICE_STATUSES_SUCCESS, {
        invoiceStatuses: data.data.invoice_status
      })
      commit(types.FETCH_CONTACTS_SUCCESS, {
        contacts: data.data.contacts
      })
      commit(types.FETCH_COLLECTIONS_SUCCESS, {
        collections: data.data.my_collections
      })
    } catch (e) {
      commit(types.FETCH_TRADESHOWS_SUCCESS, { tradeShows: [] })
      commit(types.FETCH_DRAFT_ORDERS_SUCCESS, { draftOrders: [] })
      commit(types.FETCH_INVOICE_STATUSES_SUCCESS, { invoiceStatuses: [] })
      commit(types.FETCH_CONTACTS_SUCCESS, { contacts: [] })
      commit(types.FETCH_COLLECTIONS_SUCCESS, { collections: [] })
      commit(types.FETCH_BUYER_DASHBOARD_FAILURE)
    }
  },
  fetchOrderSummary ({ commit }) {
    commit(types.FETCH_ORDER_SUMMARY_SUCCESS, {
      orderSummary: ORDER_SUMMARY_PREVIEW
    })
  }
}
